export default "__VITE_ASSET__D0myG3cp__"